import BoutonPrincipal from './BoutonPrincipal';

function OffrePrestation({ image, titre, description, lien }) {
  return (
    <div className="w-full max-w-[320px] h-auto pb-5 bg-white dark:bg-bleu-gris rounded-[5px] shadow-md">
      <img src={image} alt={titre} className="rounded-t-[5px] w-full object-cover" />
      <div className="flex flex-col items-center justify-between gap-4 px-4 py-6">
        <h3 className="text-gris-sombre dark:text-fond-sombre text-2xl font-bold text-center">{titre}</h3>
        <p className="text-gris-sombre dark:text-fond-sombre text-[13px] font-normal text-center">{description}</p>
        <BoutonPrincipal titre="En savoir plus" lien={lien} />
      </div>
    </div>
  );
}

export default OffrePrestation;